import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { usePageTracking } from "@/hooks/usePageTracking";

// Toast layers are only needed after the first interaction, so they load
// as separate chunks instead of blocking the initial bundle.
const Toaster = lazy(() => import("@/components/ui/toaster").then((m) => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then((m) => ({ default: m.Toaster })));

const Home = lazy(() => import("./pages/Home"));
const Work = lazy(() => import("./pages/Work"));
const Contact = lazy(() => import("./pages/Contact"));
const CheckoutReturn = lazy(() => import("./pages/CheckoutReturn"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));
const UnderConstruction = lazy(() => import("./pages/UnderConstruction"));

// While true, visitors only see the "Under Construction" landing page.
// The admin panel stays reachable at /admin. Flip to false to reopen the site.
const UNDER_CONSTRUCTION = true;

const queryClient = new QueryClient();

const AppWithTracking = () => {
  usePageTracking();
  return (
    <Suspense fallback={<div />}>
      <Routes>
        {UNDER_CONSTRUCTION ? (
          <>
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<UnderConstruction />} />
          </>
        ) : (
          <>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/work/:slug" element={<Work />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/checkout/return" element={<CheckoutReturn />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
};

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Suspense fallback={null}>
          <Toaster />
          <Sonner />
        </Suspense>
        <BrowserRouter>
          <AppWithTracking />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
